import React from 'react';
import { Label } from '../../Label';
import { Text } from '../../Text';
import styles from './FormItem.scss';
export var FormItem = function FormItem(props) {
  return React.createElement("div", {
    className: props.className,
    "data-test": props.dataTest
  }, React.createElement("div", {
    className: styles.labelContainer
  }, React.createElement(Label, {
    htmlFor: props.htmlFor,
    disabled: props.disabled,
    "data-test": "".concat(props.dataTest, "-label")
  }, props.label, " ", props.required && React.createElement("span", {
    "data-test": "requiredLabel"
  }, "(required)")), props.description && React.createElement(Text, {
    className: styles.description,
    size: "small",
    color: props.disabled ? 'disabled' : 'light',
    "data-test": "".concat(props.dataTest, "-description")
  }, props.description)), props.children);
};
FormItem.displayName = 'FormItem';